// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header.sched-header {
  --border-width: 0;
  box-shadow: none;
}

.sched-toolbar {
  --background: #143D17;
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 14px;
  --padding-bottom: 14px;
  --border-width: 0;
  --min-height: auto;
}

.sched-toolbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sched-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.sched-close-btn {
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

ion-content.sched-content {
  --background: #f7f7f7;
}

.sched-section {
  background: #fff;
  border-radius: 12px;
  border: 0.5px solid #eee;
  margin: 12px 14px 0;
  overflow: hidden;
}

.sched-section:focus {
  outline: none;
}

.sched-section-label {
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #aaa;
  padding: 10px 14px 0;
}

.sched-cal-wrap {
  --ion-color-primary: #2E7D32;
  --ion-color-primary-rgb: 15, 110, 86;
  --ion-color-primary-contrast: #fff;
  --ion-color-primary-shade: #0c5e49;
  --ion-color-primary-tint: #278168;
  display: flex;
  justify-content: center;
  padding: 4px 0 8px;
}

ion-datetime.sched-datetime {
  --background: #fff;
  --title-color: #1a1a1a;
  border-radius: 0;
  max-width: 100%;
  width: 100%;
}

.sched-date-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #E8F5E9;
  border-top: 0.5px solid #A5D6A7;
  font-size: 12px;
  font-weight: 500;
  color: #2E7D32;
}

.sched-prompt,
.sched-empty {
  padding: 20px 14px;
  font-size: 12px;
  color: #aaa;
  text-align: center;
}

.sched-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px 14px;
  font-size: 12px;
  color: #aaa;
}

.sched-spinner {
  --color: #2E7D32;
  width: 20px;
  height: 20px;
}

.sched-slot-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px 12px;
}

.sched-slot {
  padding: 13px 16px;
  border-radius: 9px;
  border: 0.5px solid #eee;
  background: #fafafa;
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  text-align: center;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.15s ease;
}
.sched-slot:active:not([disabled]) {
  background: #E8F5E9;
  border-color: #A5D6A7;
}

.sched-slot-on {
  background: #2E7D32;
  color: #fff;
  border-color: #2E7D32;
}

.sched-slot-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.sched-slot-remaining {
  font-size: 10px;
  opacity: 0.7;
  margin-left: 6px;
}

.sched-confirm-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 12px;
  border: 0.5px solid #A5D6A7;
  margin: 10px 14px 0;
  padding: 14px;
}

.sched-confirm-icon {
  width: 40px;
  height: 40px;
  background: #2E7D32;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sched-confirm-label {
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #2E7D32;
  margin-bottom: 3px;
}

.sched-confirm-date {
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 2px;
}

.sched-confirm-time {
  font-size: 12px;
  color: #aaa;
}

ion-footer.sched-footer {
  --background: transparent;
  box-shadow: none;
  border: none;
}

.sched-footer-bar {
  padding: 10px 14px;
  background: #fff;
  border-top: 0.5px solid #eee;
}

.sched-footer-btn {
  width: 100%;
  background: #2E7D32;
  color: #fff;
  border: none;
  border-radius: 9px;
  padding: 14px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s ease;
}
.sched-footer-btn[disabled] {
  opacity: 0.45;
  cursor: not-allowed;
}
.sched-footer-btn:active:not([disabled]) {
  background: #276a2b;
}

.theme-red .sched-toolbar {
  --background: #4A0000;
}
.theme-red .sched-footer-btn {
  background: #eb1c2e;
}
.theme-red .sched-slot-on {
  background: #eb1c2e;
  border-color: #eb1c2e;
  color: #fff;
}
.theme-red .sched-spinner {
  color: #eb1c2e;
}
.theme-red .sched-cal-wrap {
  --ion-color-primary: #eb1c2e;
  --ion-color-primary-rgb: 198, 40, 40;
  --ion-color-primary-shade: #a62020;
  --ion-color-primary-tint: #d43232;
}
.theme-red .sched-date-preview {
  color: #eb1c2e;
  border-color: #eb1c2e;
  background: rgba(198, 40, 40, 0.08);
}
.theme-red .sched-date-preview svg {
  stroke: #eb1c2e;
}
.theme-red .sched-slot-on {
  background: #eb1c2e;
  border-color: #eb1c2e;
  color: #fff;
}
.theme-red .sched-confirm-icon {
  background: #eb1c2e;
}

@media (min-width: 993px) {
  .sched-toolbar-inner {
    max-width: 1040px;
    margin: 0 auto;
  }
  .sched-title {
    font-size: 20px;
  }
  .sched-close-btn {
    width: 34px;
    height: 34px;
  }
  ion-content.sched-content {
    --background: #f0f1f2;
  }
  ion-content.sched-content {
    padding: 24px;
    --overflow: hidden;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .sched-row {
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    gap: 20px;
    max-width: 1040px;
    width: 100%;
    margin: 0 auto;
    flex: 1 1 auto;
    min-height: 0;
    height: 100%;
  }
  .sched-section {
    margin: 0;
    flex: 1 1 0;
  }
  .sched-row > .sched-section:first-child {
    flex: 0 0 360px;
    height: 100%;
    overflow: visible;
  }
  .sched-row > .sched-section:not(:first-child) {
    flex: 1 1 480px;
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: 100%;
    overflow: hidden;
  }
  .sched-row > .sched-section:not(:first-child) .sched-section-label {
    flex-shrink: 0;
  }
  .sched-row > .sched-section:not(:first-child) .sched-slot-list {
    overflow-y: auto;
    flex: 1 1 auto;
    min-height: 0;
    max-height: 100%;
  }
  .sched-confirm-card {
    max-width: 1040px;
    margin: 12px auto 0;
    margin-left: calc(50% - 520px + 380px);
  }
  .sched-slot-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 14px 16px 18px;
  }
  .sched-slot {
    padding: 16px;
    font-size: 14px;
  }
  .sched-confirm-card {
    grid-column: 2;
    margin: 0;
  }
  .sched-footer-bar {
    max-width: 1040px;
    margin: 0 auto;
    padding: 16px 24px 20px;
    border-top: none;
    background: transparent;
  }
  .sched-footer-btn {
    padding: 16px;
    font-size: 15px;
  }
}
.sched-confirm-card {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/custom popup/schedulePopup/schedulePopup.scss","webpack://./src/app/custom%20popup/schedulePopup/schedulePopup.scss"],"names":[],"mappings":"AAWA;EACE,iBAAA;EACA,gBAAA;ACVF;;ADaA;EACE,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;ACVF;;ADaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACVF;;ADaA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;ACVF;;ADaA;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;ACVF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;ACZF;;ADeA;EACE,aAAA;ACZF;;ADeA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAlEe;EAmEf,oBAAA;ACZF;;ADiBA;EACE,4BAAA;EACA,oCAAA;EACA,kCAAA;EACA,kCAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;ACdF;;ADiBA;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;ACdF;;ADmBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAtGe;EAuGf,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,cA3Ge;AC2FjB;;ADqBA;;EAEE,kBAAA;EACA,eAAA;EACA,WA/Ge;EAgHf,kBAAA;AClBF;;ADqBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,WA1He;ACwGjB;;ADqBA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AClBF;;ADqBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AClBF;;ADqBA;EACE,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAlJe;EAmJf,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,0BAAA;AClBF;ADoBE;EACE,mBA5Ja;EA6Jb,qBA5Ja;AC0IjB;;ADsBA;EACE,mBAnKe;EAoKf,WAAA;EACA,qBArKe;ACkJjB;;ADsBA;EACE,YAAA;EACA,mBAAA;ACnBF;;ADsBA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;ACnBF;;ADwBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;ACrBF;;ADwBA;EACE,WAAA;EACA,YAAA;EACA,mBAnMe;EAoMf,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;ACrBF;;ADwBA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAhNe;EAiNf,kBAAA;ACrBF;;ADwBA;EACE,eAAA;EACA,gBAAA;EACA,cAnNe;EAoNf,kBAAA;ACrBF;;ADwBA;EACE,eAAA;EACA,WAxNe;ACmMjB;;AD0BA;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;ACvBF;;AD0BA;EACE,kBAAA;EACA,gBAAA;EACA,4BAAA;ACvBF;;AD0BA;EACE,WAAA;EACA,mBAhPe;EAiPf,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,8BAAA;ACvBF;ADyBE;EACE,aAAA;EACA,mBAAA;ACvBJ;AD0BE;EACE,mBAAA;ACxBJ;;AD4BE;EAAsB,qBAAA;ACxBxB;ADyBE;EAAsB,mBAAA;ACtBxB;ADuBE;EAAsB,mBAAA;EAAqB,qBAAA;EAAuB,WAAA;AClBpE;ADmBE;EAAsB,cAAA;AChBxB;ADmBE;EACE,4BAAA;EACA,oCAAA;EACA,kCAAA;EACA,iCAAA;ACjBJ;ADqBE;EACE,cAAA;EACA,qBAAA;EACA,mCAAA;ACnBJ;ADoBI;EAAM,eAAA;ACjBV;ADqBE;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;ACnBJ;ADuBE;EACE,mBAAA;ACrBJ;;AD2BA;EAEE;IACE,iBAAA;IACA,cAAA;ECzBF;ED4BA;IACE,eAAA;EC1BF;ED6BA;IACE,WAAA;IACA,YAAA;EC3BF;ED8BF;IACI,qBAAA;EC5BF;ED+BF;IACI,aAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;EC7BF;EDgCF;IACI,aAAA;IACA,oBAAA;IACA,iBAAA;IACA,SAAA;IACA,iBAAA;IACA,WAAA;IACA,cAAA;IACA,cAAA;IACA,aAAA;IACA,YAAA;EC9BF;EDiCA;IACE,SAAA;IACA,WAAA;EC/BF;EDmCA;IACE,eAAA;IACA,YAAA;IACA,iBAAA;ECjCF;EDqCA;IACE,eAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;ECnCF;EDuCA;IACE,cAAA;ECrCF;EDyCA;IACE,gBAAA;IACA,cAAA;IACA,aAAA;IACA,gBAAA;ECvCF;ED2CA;IACE,iBAAA;IACA,mBAAA;IACA,sCAAA;ECzCF;ED6CA;IACE,aAAA;IACA,8BAAA;IACA,SAAA;IACA,uBAAA;EC3CF;ED8CA;IACE,aAAA;IACA,eAAA;EC5CF;ED+CA;IACE,cAAA;IACA,SAAA;EC7CF;EDgDA;IACE,iBAAA;IACA,cAAA;IACA,uBAAA;IACA,gBAAA;IACA,uBAAA;EC9CF;EDiDA;IACE,aAAA;IACA,eAAA;EC/CF;AACF;ADkDE;EACE,aAAA;AChDJ","sourcesContent":["// ─── Design Tokens ───────────────────────────────────────────────────────────\r\n$primary:        #2E7D32;\r\n$primary-light:  #E8F5E9;\r\n$primary-border: #A5D6A7;\r\n$hero-bg:        #143D17;\r\n$text-primary:   #1a1a1a;\r\n$text-muted:     #aaa;\r\n$border:         #eee;\r\n\r\n\r\n// ─── Header ──────────────────────────────────────────────────────────────────\r\nion-header.sched-header {\r\n  --border-width: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.sched-toolbar {\r\n  --background: #{$hero-bg};\r\n  --padding-start: 16px;\r\n  --padding-end: 16px;\r\n  --padding-top: 14px;\r\n  --padding-bottom: 14px;\r\n  --border-width: 0;\r\n  --min-height: auto;\r\n}\r\n\r\n.sched-toolbar-inner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.sched-title {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #fff;\r\n}\r\n\r\n.sched-close-btn {\r\n  width: 30px;\r\n  height: 30px;\r\n  background: rgba(255, 255, 255, 0.12);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n// ─── Content ─────────────────────────────────────────────────────────────────\r\nion-content.sched-content {\r\n  --background: #f7f7f7;\r\n}\r\n\r\n.sched-section {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  border: 0.5px solid $border;\r\n  margin: 12px 14px 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.sched-section:focus {\r\n  outline: none;\r\n}\r\n\r\n.sched-section-label {\r\n  font-size: 9px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.8px;\r\n  text-transform: uppercase;\r\n  color: $text-muted;\r\n  padding: 10px 14px 0;\r\n}\r\n\r\n\r\n// ─── Calendar ────────────────────────────────────────────────────────────────\r\n.sched-cal-wrap {\r\n  --ion-color-primary:          #{$primary};\r\n  --ion-color-primary-rgb:      15, 110, 86;\r\n  --ion-color-primary-contrast: #fff;\r\n  --ion-color-primary-shade:    #0c5e49;\r\n  --ion-color-primary-tint:     #278168;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 4px 0 8px;\r\n}\r\n\r\nion-datetime.sched-datetime {\r\n  --background: #fff;\r\n  --title-color: #{$text-primary};\r\n  border-radius: 0;\r\n  max-width: 100%;\r\n  width: 100%;\r\n}\r\n\r\n\r\n// ─── Date Preview ─────────────────────────────────────────────────────────────\r\n.sched-date-preview {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 14px;\r\n  background: $primary-light;\r\n  border-top: 0.5px solid $primary-border;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: $primary;\r\n}\r\n\r\n\r\n// ─── Slots ───────────────────────────────────────────────────────────────────\r\n.sched-prompt,\r\n.sched-empty {\r\n  padding: 20px 14px;\r\n  font-size: 12px;\r\n  color: $text-muted;\r\n  text-align: center;\r\n}\r\n\r\n.sched-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 20px 14px;\r\n  font-size: 12px;\r\n  color: $text-muted;\r\n}\r\n\r\n.sched-spinner {\r\n  --color: #{$primary};\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.sched-slot-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 10px 12px 12px;\r\n}\r\n\r\n.sched-slot {\r\n  padding: 13px 16px;\r\n  border-radius: 9px;\r\n  border: 0.5px solid $border;\r\n  background: #fafafa;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: $text-primary;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  transition: all 0.15s ease;\r\n\r\n  &:active:not([disabled]) {\r\n    background: $primary-light;\r\n    border-color: $primary-border;\r\n  }\r\n}\r\n\r\n.sched-slot-on {\r\n  background: $primary;\r\n  color: #fff;\r\n  border-color: $primary;\r\n}\r\n\r\n.sched-slot-disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.sched-slot-remaining {\r\n  font-size: 10px;\r\n  opacity: 0.7;\r\n  margin-left: 6px;\r\n}\r\n\r\n\r\n// ─── Confirmation Card ────────────────────────────────────────────────────────\r\n.sched-confirm-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  border: 0.5px solid $primary-border;\r\n  margin: 10px 14px 0;\r\n  padding: 14px;\r\n}\r\n\r\n.sched-confirm-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  background: $primary;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sched-confirm-label {\r\n  font-size: 9px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.8px;\r\n  color: $primary;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.sched-confirm-date {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: $text-primary;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.sched-confirm-time {\r\n  font-size: 12px;\r\n  color: $text-muted;\r\n}\r\n\r\n\r\n// ─── Footer ───────────────────────────────────────────────────────────────────\r\nion-footer.sched-footer {\r\n  --background: transparent;\r\n  box-shadow: none;\r\n  border: none;\r\n}\r\n\r\n.sched-footer-bar {\r\n  padding: 10px 14px;\r\n  background: #fff;\r\n  border-top: 0.5px solid $border;\r\n}\r\n\r\n.sched-footer-btn {\r\n  width: 100%;\r\n  background: $primary;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 9px;\r\n  padding: 14px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s ease;\r\n\r\n  &[disabled] {\r\n    opacity: 0.45;\r\n    cursor: not-allowed;\r\n  }\r\n\r\n  &:active:not([disabled]) {\r\n    background: darken($primary, 5%);\r\n  }\r\n}\r\n.theme-red {\r\n  .sched-toolbar      { --background: #4A0000; }\r\n  .sched-footer-btn   { background: #eb1c2e; }\r\n  .sched-slot-on      { background: #eb1c2e; border-color: #eb1c2e; color: #fff; }\r\n  .sched-spinner      { color: #eb1c2e; }\r\n\r\n  // ── Date circle highlight (fixes the green \"5\")\r\n  .sched-cal-wrap {\r\n    --ion-color-primary:          #eb1c2e;\r\n    --ion-color-primary-rgb:      198, 40, 40;\r\n    --ion-color-primary-shade:    #a62020;\r\n    --ion-color-primary-tint:     #d43232;\r\n  }\r\n\r\n  // ── \"Tuesday, May 5, 2026\" date preview banner\r\n  .sched-date-preview {\r\n    color: #eb1c2e;\r\n    border-color: #eb1c2e;\r\n    background: rgba(198, 40, 40, 0.08);\r\n    svg { stroke: #eb1c2e; }\r\n  }\r\n\r\n  // ── Selected time slot\r\n  .sched-slot-on {\r\n    background: #eb1c2e;\r\n    border-color: #eb1c2e;\r\n    color: #fff;\r\n  }\r\n\r\n  // ── Tick/checkmark circle in confirm card\r\n  .sched-confirm-icon {\r\n    background: #eb1c2e;\r\n  }\r\n}\r\n// ═══════════════════════════════════════════════════\r\n// DESKTOP / WEB LAYOUT (≥993px) — mobile rules above untouched\r\n// ═══════════════════════════════════════════════════\r\n@media (min-width: 993px) {\r\n\r\n  .sched-toolbar-inner {\r\n    max-width: 1040px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .sched-title {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .sched-close-btn {\r\n    width: 34px;\r\n    height: 34px;\r\n  }\r\n\r\nion-content.sched-content {\r\n    --background: #f0f1f2;\r\n  }\r\n\r\nion-content.sched-content {\r\n    padding: 24px;\r\n    --overflow: hidden;   // stop the whole page from scrolling\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n  }\r\n\r\n.sched-row {\r\n    display: flex;\r\n    align-items: stretch;\r\n    flex-wrap: nowrap;\r\n    gap: 20px;\r\n    max-width: 1040px;\r\n    width: 100%;\r\n    margin: 0 auto;\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    height: 100%;\r\n  }\r\n\r\n  .sched-section {\r\n    margin: 0;\r\n    flex: 1 1 0;\r\n  }\r\n\r\n// Calendar column — left, fixed width, no internal scroll\r\n  .sched-row > .sched-section:first-child {\r\n    flex: 0 0 360px;\r\n    height: 100%;\r\n    overflow: visible;\r\n  }\r\n// Slots column(s) — right, fills remaining space\r\n  // section itself doesn't scroll — only its inner list does\r\n  .sched-row > .sched-section:not(:first-child) {\r\n    flex: 1 1 480px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 0;\r\n    max-height: 100%;\r\n    overflow: hidden; // clip to card edges, inner list handles its own scroll\r\n  }\r\n\r\n  // The label (\"AVAILABLE TIME SLOTS\") stays fixed at top of the column\r\n  .sched-row > .sched-section:not(:first-child) .sched-section-label {\r\n    flex-shrink: 0;\r\n  }\r\n\r\n// Only this scrolls\r\n  .sched-row > .sched-section:not(:first-child) .sched-slot-list {\r\n    overflow-y: auto;\r\n    flex: 1 1 auto;\r\n    min-height: 0;\r\n    max-height: 100%;\r\n  }\r\n\r\n  // Confirm card — aligns under the slots column, right side\r\n  .sched-confirm-card {\r\n    max-width: 1040px;\r\n    margin: 12px auto 0;\r\n    margin-left: calc(50% - 520px + 380px); // aligns under slots column when centered\r\n  }\r\n\r\n  // time buttons: stacked list → 2-col grid\r\n  .sched-slot-list {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    padding: 14px 16px 18px;\r\n  }\r\n\r\n  .sched-slot {\r\n    padding: 16px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .sched-confirm-card {\r\n    grid-column: 2;\r\n    margin: 0;\r\n  }\r\n\r\n  .sched-footer-bar {\r\n    max-width: 1040px;\r\n    margin: 0 auto;\r\n    padding: 16px 24px 20px;\r\n    border-top: none;\r\n    background: transparent;\r\n  }\r\n\r\n  .sched-footer-btn {\r\n    padding: 16px;\r\n    font-size: 15px;\r\n  }\r\n}\r\n// ── Hide \"Selected Slot\" confirm card on desktop ────────────────────\r\n  .sched-confirm-card {\r\n    display: none;\r\n  }","ion-header.sched-header {\n  --border-width: 0;\n  box-shadow: none;\n}\n\n.sched-toolbar {\n  --background: #143D17;\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --padding-top: 14px;\n  --padding-bottom: 14px;\n  --border-width: 0;\n  --min-height: auto;\n}\n\n.sched-toolbar-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sched-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.sched-close-btn {\n  width: 30px;\n  height: 30px;\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\nion-content.sched-content {\n  --background: #f7f7f7;\n}\n\n.sched-section {\n  background: #fff;\n  border-radius: 12px;\n  border: 0.5px solid #eee;\n  margin: 12px 14px 0;\n  overflow: hidden;\n}\n\n.sched-section:focus {\n  outline: none;\n}\n\n.sched-section-label {\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #aaa;\n  padding: 10px 14px 0;\n}\n\n.sched-cal-wrap {\n  --ion-color-primary: #2E7D32;\n  --ion-color-primary-rgb: 15, 110, 86;\n  --ion-color-primary-contrast: #fff;\n  --ion-color-primary-shade: #0c5e49;\n  --ion-color-primary-tint: #278168;\n  display: flex;\n  justify-content: center;\n  padding: 4px 0 8px;\n}\n\nion-datetime.sched-datetime {\n  --background: #fff;\n  --title-color: #1a1a1a;\n  border-radius: 0;\n  max-width: 100%;\n  width: 100%;\n}\n\n.sched-date-preview {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background: #E8F5E9;\n  border-top: 0.5px solid #A5D6A7;\n  font-size: 12px;\n  font-weight: 500;\n  color: #2E7D32;\n}\n\n.sched-prompt,\n.sched-empty {\n  padding: 20px 14px;\n  font-size: 12px;\n  color: #aaa;\n  text-align: center;\n}\n\n.sched-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 20px 14px;\n  font-size: 12px;\n  color: #aaa;\n}\n\n.sched-spinner {\n  --color: #2E7D32;\n  width: 20px;\n  height: 20px;\n}\n\n.sched-slot-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px 12px 12px;\n}\n\n.sched-slot {\n  padding: 13px 16px;\n  border-radius: 9px;\n  border: 0.5px solid #eee;\n  background: #fafafa;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1a1a1a;\n  text-align: center;\n  cursor: pointer;\n  font-family: inherit;\n  transition: all 0.15s ease;\n}\n.sched-slot:active:not([disabled]) {\n  background: #E8F5E9;\n  border-color: #A5D6A7;\n}\n\n.sched-slot-on {\n  background: #2E7D32;\n  color: #fff;\n  border-color: #2E7D32;\n}\n\n.sched-slot-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.sched-slot-remaining {\n  font-size: 10px;\n  opacity: 0.7;\n  margin-left: 6px;\n}\n\n.sched-confirm-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border-radius: 12px;\n  border: 0.5px solid #A5D6A7;\n  margin: 10px 14px 0;\n  padding: 14px;\n}\n\n.sched-confirm-icon {\n  width: 40px;\n  height: 40px;\n  background: #2E7D32;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.sched-confirm-label {\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #2E7D32;\n  margin-bottom: 3px;\n}\n\n.sched-confirm-date {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1a1a1a;\n  margin-bottom: 2px;\n}\n\n.sched-confirm-time {\n  font-size: 12px;\n  color: #aaa;\n}\n\nion-footer.sched-footer {\n  --background: transparent;\n  box-shadow: none;\n  border: none;\n}\n\n.sched-footer-bar {\n  padding: 10px 14px;\n  background: #fff;\n  border-top: 0.5px solid #eee;\n}\n\n.sched-footer-btn {\n  width: 100%;\n  background: #2E7D32;\n  color: #fff;\n  border: none;\n  border-radius: 9px;\n  padding: 14px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n.sched-footer-btn[disabled] {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.sched-footer-btn:active:not([disabled]) {\n  background: #276a2b;\n}\n\n.theme-red .sched-toolbar {\n  --background: #4A0000;\n}\n.theme-red .sched-footer-btn {\n  background: #eb1c2e;\n}\n.theme-red .sched-slot-on {\n  background: #eb1c2e;\n  border-color: #eb1c2e;\n  color: #fff;\n}\n.theme-red .sched-spinner {\n  color: #eb1c2e;\n}\n.theme-red .sched-cal-wrap {\n  --ion-color-primary: #eb1c2e;\n  --ion-color-primary-rgb: 198, 40, 40;\n  --ion-color-primary-shade: #a62020;\n  --ion-color-primary-tint: #d43232;\n}\n.theme-red .sched-date-preview {\n  color: #eb1c2e;\n  border-color: #eb1c2e;\n  background: rgba(198, 40, 40, 0.08);\n}\n.theme-red .sched-date-preview svg {\n  stroke: #eb1c2e;\n}\n.theme-red .sched-slot-on {\n  background: #eb1c2e;\n  border-color: #eb1c2e;\n  color: #fff;\n}\n.theme-red .sched-confirm-icon {\n  background: #eb1c2e;\n}\n\n@media (min-width: 993px) {\n  .sched-toolbar-inner {\n    max-width: 1040px;\n    margin: 0 auto;\n  }\n  .sched-title {\n    font-size: 20px;\n  }\n  .sched-close-btn {\n    width: 34px;\n    height: 34px;\n  }\n  ion-content.sched-content {\n    --background: #f0f1f2;\n  }\n  ion-content.sched-content {\n    padding: 24px;\n    --overflow: hidden;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n  .sched-row {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: nowrap;\n    gap: 20px;\n    max-width: 1040px;\n    width: 100%;\n    margin: 0 auto;\n    flex: 1 1 auto;\n    min-height: 0;\n    height: 100%;\n  }\n  .sched-section {\n    margin: 0;\n    flex: 1 1 0;\n  }\n  .sched-row > .sched-section:first-child {\n    flex: 0 0 360px;\n    height: 100%;\n    overflow: visible;\n  }\n  .sched-row > .sched-section:not(:first-child) {\n    flex: 1 1 480px;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    max-height: 100%;\n    overflow: hidden;\n  }\n  .sched-row > .sched-section:not(:first-child) .sched-section-label {\n    flex-shrink: 0;\n  }\n  .sched-row > .sched-section:not(:first-child) .sched-slot-list {\n    overflow-y: auto;\n    flex: 1 1 auto;\n    min-height: 0;\n    max-height: 100%;\n  }\n  .sched-confirm-card {\n    max-width: 1040px;\n    margin: 12px auto 0;\n    margin-left: calc(50% - 520px + 380px);\n  }\n  .sched-slot-list {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n    padding: 14px 16px 18px;\n  }\n  .sched-slot {\n    padding: 16px;\n    font-size: 14px;\n  }\n  .sched-confirm-card {\n    grid-column: 2;\n    margin: 0;\n  }\n  .sched-footer-bar {\n    max-width: 1040px;\n    margin: 0 auto;\n    padding: 16px 24px 20px;\n    border-top: none;\n    background: transparent;\n  }\n  .sched-footer-btn {\n    padding: 16px;\n    font-size: 15px;\n  }\n}\n.sched-confirm-card {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
